export const dropdownStyles = () => {
    return {
        input: (base) => ({
            ...base,
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '100%',
            color: '#ffffff',
            outline: 'none',
            background: 'transparent',
            padding: 0,
            margin: 0
        }),
        control: (base) => ({
            ...base,
            width: '100%',
            maxWidth: '375px',
            background: 'transparent',
            border: '1px solid #7D61A7',
            borderRadius: '65px',
            padding: '0 16px',
            minHeight: 'auto',
            cursor: 'pointer'
        }),
        indicatorSeparator: () => null,
        dropdownIndicator: (base) => ({
            ...base,
            paddingRight: 0
        }),
        placeholder: (base) => ({
            ...base,
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '100%',
            opacity: 1,
            color: '#AEAEC1'
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '5px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            marginTop: '5px',
            background: '#4743A2',
            border: '1px solid #7D61A7',
            padding: 0,
            zIndex: 1000
        }),
        option: (base, { isFocused }) => ({
            ...base,
            margin: 0,
            cursor: 'pointer',
            color: isFocused ? '#4743A2' : '#ffffff',
            backgroundColor: isFocused ? '#ffffff' : 'transparent',
            ':hover': {
                backgroundColor: '#ffffff',
                color: '#4743A2'
            }
        }),
        singleValue: (base) => ({
            ...base,
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '100%',
            color: '#ffffff',
            margin: '0'
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0'
        })
    };
};
